import { Injectable } from "@angular/core";
import { Pessoa } from "@tivic-team/manager-ts/dist/grl";
import { Concessao } from "@tivic-team/manager-ts/dist/mob/entities/concessao/concessao.entity";
import { Linha } from "@tivic-team/manager-ts/dist/mob/entities/linha/linha.entity";
import { Vistoria } from "@tivic-team/manager-ts/dist/mob/entities/vistoria/vistoria.entity";
import { ConcessaoController } from "app/controllers/mob/concessao.controller";
import { ConcessaoColetivoUrbanoDTO } from "app/model/dtos/mob/concessao-coletivo-urbano.dto";
import { ConcessaoColetivoRuralDTO } from "app/model/dtos/mob/concessao-coletivorural.dto";
import { ConcessaoTaxiDTO } from "app/model/dtos/mob/concessao-taxi.dto";
import { ConcessaoVeiculoDTO } from "app/model/dtos/mob/concessao-veiculo.dto";
import { ConcessaoDTO } from "app/model/dtos/mob/concessao.dto";
import { ConcessionarioPessoaDTO } from "app/model/dtos/mob/concessionario-pessoa.dto";
import { PermissaoTaxiDTO } from 'app/model/dtos/mob/permissao-taxi.dto';
import { RelatorioConcessaoListDTO } from "app/model/dtos/mob/relatorio-concessao.dto";
import { LoaderService } from "../loader.service";
import { ConcessaoTaxiSearch } from './concessao-taxi.search';
import { ConcessaoSearch } from "./concessao.search";

@Injectable({
  providedIn: "root",
})
export class ConcessaoService {
  constructor(
    private _concessaoController: ConcessaoController,
    private _loaderService: LoaderService
  ) { }

  async getAllConcessoes(isLoading: boolean = true): Promise<ConcessaoDTO[]> {
    try {
      if (isLoading) this._loaderService.show();

      return await this._concessaoController.getAll().finally(() => {
        if (isLoading) this._loaderService.hide();
      })
    } catch (error) {
      return error
    }
  }

  async findConcessao(concessaoSearch?: ConcessaoSearch): Promise<ConcessaoDTO[]> {
    this._loaderService.show();

    try {
      return await this._concessaoController.findConcessao((concessaoSearch && concessaoSearch.getFilters()) || null).finally(() => this._loaderService.hide());

    } catch (error) {
      this._loaderService.hide();
      return [];
    }
  }

  async findRelatorioConcessao(concessaoSearch?: ConcessaoSearch): Promise<RelatorioConcessaoListDTO[]> {
    this._loaderService.show();

    try {
      return await this._concessaoController.findRelatorioConcessao((concessaoSearch && concessaoSearch.getFilters()) || null).finally(() => this._loaderService.hide());

    } catch (error) {
      this._loaderService.hide();
      return [];
    }
  }

  //Coletivo Urbano
  async findColetivoUrbano(
    concessaoSearch?: ConcessaoSearch
  ): Promise<Array<ConcessaoColetivoUrbanoDTO>> {
    this._loaderService.show();

    try {
      return await this._concessaoController.findColetivoUrbano(
        (concessaoSearch && concessaoSearch.getFilters()) || null
      ).finally(() => this._loaderService.hide());
    } catch (error) {
      this._loaderService.hide()
      return [];
    }
  }

  async findNomeConcessionarioColetivoUrbano(concessaoSearch?: ConcessaoSearch): Promise<Array<Pessoa>> {
    try {
      this._loaderService.show();
      return await this._concessaoController.findNomeConcessionarioColetivoUrbano((concessaoSearch && concessaoSearch.getFilters()) || null)
        .finally(() => this._loaderService.hide());
    } catch (error) {
      this._loaderService.hide()
      return [];
    }
  }


  async getColetivoUrbano(cdConcessao: number): Promise<ConcessaoColetivoUrbanoDTO> {
    this._loaderService.show();
    return this._concessaoController.getColetivoUrbano(cdConcessao).finally(() => this._loaderService.hide());
  }

  async saveColetivoUrbano(concessaoColetivoUrbanoDTO: ConcessaoColetivoUrbanoDTO): Promise<ConcessaoColetivoUrbanoDTO> {
    this._loaderService.show();
    if (concessaoColetivoUrbanoDTO.cdConcessao && concessaoColetivoUrbanoDTO.cdConcessao > 0) {
      return this._concessaoController.updateColetivoUrbano(concessaoColetivoUrbanoDTO).finally(() => this._loaderService.hide());
    } else {
      return this._concessaoController.createColetivoUrbano(concessaoColetivoUrbanoDTO).finally(() => this._loaderService.hide());
    }
  }

  //Coletivo Rural
  async findColetivoRural(concessaoSearch?: ConcessaoSearch): Promise<ConcessaoColetivoRuralDTO[]> {
    this._loaderService.show();
    try {
      return await this._concessaoController.findColetivoRural(
        (concessaoSearch && concessaoSearch.getFilters()) || null
      ).finally(() => this._loaderService.hide());
    } catch (error) {
      this._loaderService.hide()
      console.log(error);
      return [];
    }
  }

  async getColetivoRural(cdConcessao: number): Promise<ConcessaoColetivoRuralDTO> {
    this._loaderService.show();
    return this._concessaoController
      .getColetivoRural(cdConcessao)
      .finally(() => this._loaderService.hide());
  }

  async saveColetivoRural(concessaoColetivoRuralDTO: ConcessaoColetivoRuralDTO): Promise<ConcessaoColetivoRuralDTO> {
    this._loaderService.show();
    if (concessaoColetivoRuralDTO.concessao.cdConcessao) {
      return this._concessaoController.updateColetivoRural(concessaoColetivoRuralDTO).finally(() => this._loaderService.hide());
    } else {
      return this._concessaoController.createColetivoRural(concessaoColetivoRuralDTO).finally(() => this._loaderService.hide());
    }
  }

  //Taxi
  async findTaxi(concessaoSearch?: ConcessaoTaxiSearch): Promise<ConcessaoTaxiDTO[]> {
    this._loaderService.show();
    try {
      return await this._concessaoController.findTaxi((concessaoSearch && concessaoSearch.getFilters()) || null).finally(
        () => this._loaderService.hide());
    } catch (error) {
      this._loaderService.hide()
      console.log(error);
      return [];
    }
  }



  async getTaxi(cdConcessao: number): Promise<ConcessaoTaxiDTO> {
    this._loaderService.show();
    return this._concessaoController
      .getTaxi(cdConcessao)
      .finally(() => this._loaderService.hide());
  }

  async saveTaxi(permissaoTaxiDTO: PermissaoTaxiDTO): Promise<PermissaoTaxiDTO> {
    this._loaderService.show();
    if (permissaoTaxiDTO.cdConcessao) {
      return this._concessaoController.updateTaxi(permissaoTaxiDTO).finally(() => this._loaderService.hide());
    } else {
      return this._concessaoController.createTaxi(permissaoTaxiDTO).finally(() => this._loaderService.hide());
    }
  }

  //Mototáxi

  getConcessionarioMototaxi(cdConcessionario: number): Promise<Concessao> {
    this._loaderService.show();
    return this._concessaoController.getConcessionarioMototaxi(cdConcessionario).finally(() => this._loaderService.hide());
  }

  //Motorista de Aplicativo

  getConcessionarioMotoristaApp(cdConcessionario: number): Promise<Concessao> {
    this._loaderService.show();
    return this._concessaoController.getConcessionarioMotoristaApp(cdConcessionario).finally(() => this._loaderService.hide());
  }

  //Geral
  async getAuxiliares(cdConcessao: number): Promise<ConcessionarioPessoaDTO[]> {
    this._loaderService.show();
    return this._concessaoController
      .getAuxiliares(cdConcessao)
      .finally(() => this._loaderService.hide());
  }

  async getRepresentantes(cdConcessao: number): Promise<ConcessionarioPessoaDTO[]> {
    this._loaderService.show();
    return this._concessaoController
      .getRepresentantes(cdConcessao)
      .finally(() => this._loaderService.hide());
  }

  async getAllVeiculos(cdConcessao: number): Promise<ConcessaoVeiculoDTO[]> {
    this._loaderService.show();
    return this._concessaoController
      .getAllVeiculos(cdConcessao)
      .finally(() => this._loaderService.hide());
  }

  async getLinhas(cdConcessao: number): Promise<Linha[]> {
    this._loaderService.show();
    return this._concessaoController
      .getLinhas(cdConcessao)
      .finally(() => this._loaderService.hide());
  }

  async getVistorias(cdConcessao: number): Promise<Vistoria[]> {
    this._loaderService.show();
    return this._concessaoController
      .getVistorias(cdConcessao)
      .finally(() => this._loaderService.hide());
  }

  async getConcessao(cdConcessao: number): Promise<Concessao> {
    this._loaderService.show();
    return this._concessaoController.getConcessao(cdConcessao).finally(() => this._loaderService.hide());
  }


  async getRelatorioQuantitativo(usuario: string): Promise<Blob> {
    this._loaderService.show();
    return this._concessaoController
      .getRelatorioQuantitativo(usuario)
      .finally(() => this._loaderService.hide());
  }

  async getRelatorioConcessao(concessaoSearch: ConcessaoSearch): Promise<Blob> {
    this._loaderService.show();
    try {
      return await this._concessaoController.getRelatorioConcessao((concessaoSearch && concessaoSearch.getFilters()) || null).finally(() => this._loaderService.hide())
    } catch (error) {
      this._loaderService.hide();
      return null
    }
  }

  async getRelatorioPermissao(concessaoSearch: ConcessaoSearch): Promise<Blob> {
    this._loaderService.show();
    try {
      return await this._concessaoController.getRelatorioPermissao((concessaoSearch && concessaoSearch.getFilters()) || null).finally(() => this._loaderService.hide())
    } catch (error) {
      this._loaderService.hide();
      return null
    }
  }

  async getConcessaoEscolar(cdConcessionario: number): Promise<Concessao> {
    this._loaderService.show();
    return this._concessaoController.getConcessaoEscolar(cdConcessionario).finally(() => this._loaderService.hide());
  }

  async saveImgPermissionario(cdConcessao: number, formData: FormData): Promise<Array<string>> {
    this._loaderService.show();
    return await this._concessaoController.saveImgPermissionario(cdConcessao, formData).finally(() => this._loaderService.hide());
}
}
